const DEFAULT_BASE_INTERVAL_MS = 1500;
const DEFAULT_MAX_INTERVAL_MS = 12000;
const DEFAULT_TIMEOUT_MS = 180000;
export const sleep = (ms) => new Promise((resolve) => {
    setTimeout(resolve, ms);
});
export const getLogarithmicBackoffDelay = (attempt, baseIntervalMs = DEFAULT_BASE_INTERVAL_MS, maxIntervalMs = DEFAULT_MAX_INTERVAL_MS) => {
    const scaledDelay = baseIntervalMs * (1 + Math.log2(attempt + 1));
    return Math.min(maxIntervalMs, Math.round(scaledDelay));
};
export const settlePromiseWithin = async (promise, timeoutMs = 1000) => {
    const settled = await Promise.race([
        promise.then((value) => ({ status: 'resolved', value })),
        promise.catch((error) => ({ status: 'rejected', error })),
        sleep(timeoutMs).then(() => ({ status: 'pending' })),
    ]);
    return settled;
};
/**
 * Rejects if the promise does not settle within timeoutMs.
 * Does not cancel the underlying work (e.g. AppSync may still complete server-side).
 */
export const withTimeout = async (promise, timeoutMs, timeoutErrorMessage) => new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
        reject(new Error(timeoutErrorMessage));
    }, timeoutMs);
    promise
        .then((value) => {
        clearTimeout(timer);
        resolve(value);
    })
        .catch((err) => {
        clearTimeout(timer);
        reject(err);
    });
});
export const pollWithBackoff = async ({ poll, timeoutMs = DEFAULT_TIMEOUT_MS, baseIntervalMs = DEFAULT_BASE_INTERVAL_MS, maxIntervalMs = DEFAULT_MAX_INTERVAL_MS, }) => {
    const deadline = Date.now() + timeoutMs;
    let attempt = 0;
    while (Date.now() < deadline) {
        const current = await poll(attempt);
        if (current.done) {
            return {
                status: 'completed',
                value: current.value,
            };
        }
        attempt += 1;
        await sleep(getLogarithmicBackoffDelay(attempt, baseIntervalMs, maxIntervalMs));
    }
    const timeoutValue = await poll(attempt);
    return {
        status: 'timeout',
        value: timeoutValue.value,
    };
};
//# sourceMappingURL=pollWithBackoff.js.map